import { AlgoliaMockMapper } from './algoliaMapper';
import { ShopifyMockMapper } from './shopifyMapper';
import { UnbxdMockMapper } from './unbxdMapper';
import { BoostMockMapper } from './boostMapper';
export const platformMappers = {
    algolia: new AlgoliaMockMapper(),
    shopify: new ShopifyMockMapper(),
    unbxd: new UnbxdMockMapper(),
    boost: new BoostMockMapper()
};
export function getMapperForPlatform(platform) {
    const mapper = platformMappers[platform];
    if (!mapper) {
        console.warn(`No mapper found for platform: ${platform}, using algolia as default`);
        return platformMappers.algolia;
    }
    return mapper;
}
